export function normalizeUrl(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const looksLikeDomain = /^[a-z0-9-]+(\.[a-z0-9-]+)+/i.test(trimmed);
  if (!looksLikeDomain) return trimmed;

  return `https://${trimmed}`;
}
